import { Loader } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';

import { MainLayout } from 'src/components/layouts/main-layout/MainLayout';
import { Workspace } from 'src/pages/dashboard/features/workspace/Workspace';

export const DashboardPage: FC = observer(function DashboardPage() {
  const isLoading = false;

  const renderContent = () => {
    if (isLoading) {
      return <Loader size="l" />;
    }

    return <Workspace />;
  };

  return <MainLayout title="Dashboard">{renderContent()}</MainLayout>;
});
